var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreyaManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.53 79.59C94.19 78.69 94.81 76.87 94.39 75.28c-.05-.2-.15-.38-.23-.57-.05-.11-.08-.23-.14-.34-.33-.58-.83-1.09-1.49-1.45L73.94 62.87c1.46.94 1.53 3.01.2 4.06L31.27 90.12c-2.53 1.37-5.6 0.54-5.6-2.33V34.39l.41-22.38c-1.62-.67-3.69-1.13-5.3-1.13-7.23 0-13.78 6.29-13.78 14.94V101.73c0 8.65 6.55 14.94 13.78 14.94 1.65 0 3.33-.35 4.98-1.05.39-.17.78-.33 1.17-.54l65.6-35.49Z",
    fill: "url(#p0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.62 64.9c-.01.01-.02.02-.03.03-.83-.76-1.74-1.46-2.79-2.03L49.95 27.28c-.3-.16-.61-.28-.92-.35-.01 0-.02-.01-.03-.01-.3-.07-.61-.1-1-.1-.02 0-.03 0-.05 0-.3 0-.59.04-.87.12-.01 0-.03.01-.04.01-.28.08-.56.19-.82.34-.01 0-.02.01-.03.01-.26.15-.51.33-.73.53-.67.63-1.13 1.51-1.19 2.53l-.01 20.7c0-1.88 1.98-3.08 3.65-2.26l44.43 24.09c2.65 1.43 2.65 5.24 0 6.67L26.95 115.05c-.39.21-.78.38-1.17.54.67 7.92 6.89 13.54 13.72 13.54 2.04 0 4.13-.5 6.15-1.59l70.16-37.95c9.55-5.15 10.47-17.99 2.81-24.69Z",
    fill: "#243C83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.78 40.29L45.62 2.34c-2.02-1.09-4.11-1.59-6.15-1.59-6.18 0-11.85 4.6-13.37 11.33l-.41 22.31V86.8c.01 2.87 3.07 4.69 5.59 3.33l8.55-4.6 7.91-4.28c-1.61.59-3.39-.57-3.39-2.35V30.63c0-2.87 3.07-4.7 5.59-3.33l65.85 35.62c1.05.57 1.96 1.26 2.79 2.03 7.21-6.65 6.29-19.74-2.81-24.66Z",
    fill: "url(#p1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p0",
    x1: -7.33,
    y1: 81.2,
    x2: 71.64,
    y2: 35.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#358CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C8F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p1",
    x1: 74.53,
    y1: 6.52,
    x2: 74.53,
    y2: 80.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDB940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F4A047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E76F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E55557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E43B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E3235F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E21860"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreyaManager);
export default __webpack_public_path__ + "static/media/freya-manager.11548f286dad0a6b019e44af707a7291.svg";
export { ForwardRef as ReactComponent };